<template>
  <header class="header">
    <div class="header__main">
      <a href="#" target="_self" class="navbar-brand font-weight-bold ml-1 text-white">
        <img :src="$props.logo" height="25px;" alt="" class="d-inline-block align-top">
        {{$props.name}}
        <small style="font-size:12px" class="font-weight-light">by <b>Systemico</b>.</small>
      </a>
      <button class="header__menu" @click="showMenu()">
        <b-icon icon="list"></b-icon>
      </button>
      <div class="header__nav">
        <div class="products-link">
          <button class="btn-products" v-on:click="showProducts()">
            {{ language === 'ES' ? 'Más Productos' : (language === 'PT' ? 'Mais Produtos' : (language === 'FR' ? 'Plus de Produits' : 'More Products')) }}
          </button>
        </div>
        <div class="translate">
          <button class="btn-translate" v-on:click="showTranslate()">
            <b-icon icon="globe"></b-icon>
            <span v-if="language">{{ language }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="header__products-dropdown" v-if="products" @mouseleave="products = false">
      <div class="dropdown-header">
        <h3>{{ language === 'ES' ? 'Productos' : (language === 'PT' ? 'Produtos' : (language === 'FR' ? 'Produits' : 'Products')) }}</h3>
        <p>{{ language === 'ES' ? 'Soluciones innovadoras para tu negocio.' : (language === 'PT' ? 'Soluções inovadoras para o seu negócio.' : (language === 'FR' ? 'Des solutions innovantes pour votre entreprise.' : 'Innovative solutions for your business.')) }}</p>
      </div>
      <div class="products-grid">
        <a
          v-for="(item, index) in productsList"
          :key="index"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
          class="product-item"
        >
          <div class="product-icon">
            <img :src="$cdnSystemico + 'icons/products/' + item.icon" :alt="item.name" />
          </div>
          <div class="product-info">
            <span class="product-name">{{ item.name }}</span>
            <span class="product-description">{{ item.description[language] || item.description['EN'] }}</span>
          </div>
        </a>
      </div>
      <div class="dropdown-footer">
        <a href="https://systemico.net/products" target="_blank" rel="noopener noreferrer">
          {{ language === 'ES' ? 'Ver todos los productos' : (language === 'PT' ? 'Ver todos os produtos' : (language === 'FR' ? 'Voir tous les produits' : 'View all products')) }}
          <b-icon icon="arrow-right"></b-icon>
        </a>
      </div>
    </div>
    <div class="header__translate-dropdown" v-if="stateTranslate" @mouseleave="stateTranslate = false">
      <div class="dropdown-header">
        <h3>{{ language === 'ES' ? 'Idioma' : (language === 'PT' ? 'Idioma' : (language === 'FR' ? 'Langue' : 'Language')) }}</h3>
      </div>
      <div class="translate-grid">
        <button @click="changeLanguage('EN'); stateTranslate = false" class="translate-item">
          <span class="lang-name">English</span>
          <span class="lang-code">EN</span>
        </button>
        <button @click="changeLanguage('ES'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Español</span>
          <span class="lang-code">ES</span>
        </button>
        <button @click="changeLanguage('PT'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Português</span>
          <span class="lang-code">PT</span>
        </button>
        <button @click="changeLanguage('FR'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Français</span>
          <span class="lang-code">FR</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'headerC',
  data: function () {
    return {
      language: '',
      stateTranslate: false,
      products: false,
      showTipProducts: true,
      tipProducts: {
        ES: 'Más soluciones de <strong>software innovador</strong> para tu negocio.',
        EN: 'More <strong>innovative software</strong> solutions for your business.',
        FR: 'Plus de <strong>logiciels innovants</strong> pour votre entreprise.'
      },
      productsList: [
        {
          name: 'Suppmail',
          description: {
            EN: 'Smart email campaigns.',
            ES: 'Campañas de email inteligentes.',
            PT: 'Campanhas de e-mail inteligentes.',
            FR: 'Campagnes d\'e-mail intelligentes.'
          },
          link: 'https://pradek.co/suppmail/',
          icon: 'icon-suppmail.svg'
        },
        {
          name: 'Wabot',
          description: {
            EN: 'WhatsApp automation.',
            ES: 'Automatización de WhatsApp.',
            PT: 'Automação do WhatsApp.',
            FR: 'Automatisation de WhatsApp.'
          },
          link: 'https://systemico.net/products/wabot/',
          icon: 'icon-wabot.svg'
        },
        {
          name: 'Pugobox',
          description: {
            EN: 'Logistics and tracking.',
            ES: 'Logística y seguimiento.',
            PT: 'Logística e rastreamento.',
            FR: 'Logistique et suivi.'
          },
          link: 'https://systemico.net/products/pugobox/',
          icon: 'icon-pugobox.svg'
        },
        {
          name: 'Grumpyturtle',
          description: {
            EN: 'Customer feedback.',
            ES: 'Feedback de clientes.',
            PT: 'Feedback do cliente.',
            FR: 'Commentaires des clients.'
          },
          link: 'https://systemico.net/products/grumpyturtle/',
          icon: 'icon-grumpyturtle.svg'
        },
        {
          name: 'Chatter',
          description: {
            EN: 'Real-time communication.',
            ES: 'Comunicación en tiempo real.',
            PT: 'Comunicação em tempo real.',
            FR: 'Communication en temps réel.'
          },
          link: 'https://systemico.net/products/chatter/',
          icon: 'icon-chatter.svg'
        },
        {
          name: 'Penguin Strategy',
          description: {
            EN: 'Business intelligence.',
            ES: 'Inteligencia de negocios.',
            PT: 'Inteligência de negócios.',
            FR: 'Intelligence d\'affaires.'
          },
          link: 'https://systemico.net/products/penguinstrategy/',
          icon: 'icon-penguin.svg'
        },
        {
          name: 'Focusmeet',
          description: {
            EN: 'Productive meetings.',
            ES: 'Reuniones productivas.',
            PT: 'Reuniões produtivas.',
            FR: 'Réunions productives.'
          },
          link: 'https://systemico.net/products/focusmeet/',
          icon: 'icon-focusmeet.svg'
        },
        {
          name: 'Ducksites',
          description: {
            EN: 'Fast web builder.',
            ES: 'Constructor web rápido.',
            PT: 'Construtor de sites rápido.',
            FR: 'Constructeur de site rapide.'
          },
          link: 'https://systemico.net/products/ducksites/',
          icon: 'icon-ducksite.svg'
        },
        {
          name: 'Provedur',
          description: {
            EN: 'Supplier management.',
            ES: 'Gestión de proveedores.',
            PT: 'Gestão de fornecedores.',
            FR: 'Gestion des fournisseurs.'
          },
          link: 'https://systemico.net/products/provedur/',
          icon: 'icon-provedur.svg'
        },
        {
          name: 'Transpur',
          description: {
            EN: 'Transport solutions.',
            ES: 'Soluciones de transporte.',
            PT: 'Soluções de transporte.',
            FR: 'Solutions de transport.'
          },
          link: 'https://systemico.net/products/transpur/',
          icon: 'icon-transpur.svg'
        }
      ]
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  beforeMount () {
    this.language = this.lang
  },
  mounted () {
    /* let language = localStorage.getItem("userLanguage");
    if (language == null || language ==="ES") {
      this.language = this.lang;
    } else {
      this.language = localStorage.getItem("userLanguage");
    } */
  },
  methods: {
    showTranslate: function () {
      this.stateTranslate = !this.stateTranslate
    },
    closeTranslate: function () {
      this.stateTranslate = false
    },
    changeLanguage: function (idioma) {
      this.language = idioma
      this.$emit('changeLang', idioma)
    },
    showProducts: function () {
      this.products = !this.products
      this.showTipProducts = false
    }
  }
}
</script>

<style lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  &__main {
    padding: 0.75rem 1.5rem;
    background-color: #171e44;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-bottom: 2px solid rgb(255 128 40 / var(--tw-bg-opacity, 1));
  }

  &__nav {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__products-dropdown, &__translate-dropdown {
    position: absolute;
    top: 100%;
    right: 1.5rem;
    width: 600px;
    background: white;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 15px 35px rgba(0,0,0,0.2);
    padding: 1.5rem;
    z-index: 1000;
    display: flex;
    flex-direction: column;

    .dropdown-header {
      margin-bottom: 1.5rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid #eee;

      h3 {
        font-size: 1.25rem;
        font-weight: 700;
        color: #171e44;
        margin: 0;
      }
      p {
        font-size: 0.875rem;
        color: #6c757d;
        margin: 0.25rem 0 0;
      }
    }
  }

  &__translate-dropdown {
    width: 300px;

    .translate-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }

    .translate-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.75rem 1rem;
      border-radius: 8px;
      transition: all 0.2s;
      text-decoration: none;
      background: transparent;
      border: 1px solid #f0f0f0;
      cursor: pointer;

      &:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
        border-color: #ff8028;
      }

      .lang-name {
        font-weight: 600;
        color: #171e44;
        font-size: 1rem;
      }

      .lang-code {
        font-size: 0.75rem;
        font-weight: 700;
        color: #6c757d;
        background: #eee;
        padding: 2px 6px;
        border-radius: 4px;
      }
    }
  }

  &__products-dropdown {
    .products-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
    }

    .product-item {
      display: flex;
      align-items: center;
      padding: 0.75rem;
      border-radius: 8px;
      transition: all 0.2s;
      text-decoration: none;

      &:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
      }

      .product-icon {
        width: 40px;
        height: 40px;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .product-info {
        display: flex;
        flex-direction: column;

        .product-name {
          font-weight: 600;
          color: #171e44;
          font-size: 1rem;
        }
        .product-description {
          font-size: 0.75rem;
          color: #6c757d;
        }
      }
    }

    .dropdown-footer {
      margin-top: 1.5rem;
      padding-top: 1rem;
      border-top: 1px solid #eee;
      text-align: right;

      a {
        font-size: 0.875rem;
        font-weight: 600;
        color: #006df0;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media (max-width: 768px) {
    &__products-dropdown, &__translate-dropdown {
      left: 0;
      width: 100%;
      position: fixed;
      top: 60px;
      height: calc(100vh - 60px);
      overflow-y: auto;
      border-radius: 0;
    }

    &__products-dropdown {
      .products-grid {
        grid-template-columns: 1fr;
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    justify-content: inherit;

    &__menu {
      display: none;
    }
  }
}

.products-link {
  margin-right: 20px;

  .btn-products {
    background: transparent;
    border: 0;
    color: white;
    font-family: "Quicksand", sans-serif;
    font-size: 14px;
    font-weight: 600;
    padding: 5px 10px;
    transition: all 0.2s;

    &:hover {
      color: #ff8028;
    }
  }
}

.translate {
  margin-right: 20px;
  position: relative;

  // &.show {
  //   .btn-translate {
  //     svg {
  //       color: #ff8028;
  //     }
  //   }
  // }

  // &.show {
  //   .options-translate {
  //     height: auto;
  //   }
  // }
}

.btn-translate {
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin: 0 auto;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  svg {
    font-size: 20px;
    color: white;
    pointer-events: none;
  }

  span {
    padding: 0 4px;
    border-radius: 30px;
    background-color: white;
    font-family: "Mulish", sans-serif;
    font-size: 10px;
    font-weight: bold;
    color: #171e44;
    text-align: center;
    text-transform: uppercase;
    position: absolute;
    top: 15px;
    left: 15px;
  }

  &:hover {
    svg {
      color: #ff8028;
    }
  }
}
</style>
